module.exports = __webpack_public_path__ + "img/ai-5.e563f55d.jpg";